import { render } from "./About.vue?vue&type=template&id=5daf0cd2"
const script = {}
script.render = render

export default script